import React from 'react';
import { connect } from 'react-redux';
import { save } from 'd3-save-pdf';
import moment from 'moment';

import fetchStylistsBySalon from 'actions/stylist/fetchStylistsBySalon.action';
import STAFF_NAME from 'constants/staff/name.const';

import { getMonthlyRevenue, setMonthlyDatePickerDate, setSalonVatRate } from 'reports/actions';
import D3 from 'reports/DashboardReports/D3';
import StylistTypeDropdown from 'reports/DashboardReports/StylistTypeDropdown';
import RevenueByStylistMonthlyTableContainer from 'reports/RevenueTables/RevenueByStylistMonthlyTable';

import 'styles/reports/chart.scss';
import 'styles/cashup/index.scss';

const ReportsProps = ['monthlyRevenueReport'];

class MonthlyDashboardReports extends React.Component {
  // eslint-disable-next-line react/sort-comp
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      fromDateChanged: false,
      toDateChanged: false,
      openDropdown: false,
      selectedStaff: STAFF_NAME.all,
      isEmployed: '',
      stylists: [],
    };
  }

  componentDidMount() {
    this.props.fetchStylistsBySalon(this.props.salonId);
    if (
      this.props.lastMonthlyDatesSelected &&
      this.props.lastMonthlyDatesSelected.toDate &&
      this.props.lastMonthlyDatesSelected.fromDate
    ) {
      if (
        moment(this.props.lastMonthlyDatesSelected.fromDate).isBefore(
          moment(this.props.lastMonthlyDatesSelected.toDate),
        ) &&
        moment(this.props.lastMonthlyDatesSelected.toDate).diff(
          moment(this.props.lastMonthlyDatesSelected.fromDate),
          'month',
        ) <= 12
      ) {
        this.props.getMonthlyRevenue(
          this.props.salonId,
          moment(this.props.lastMonthlyDatesSelected).fromDate,
          moment(this.props.lastMonthlyDatesSelected.toDate),
        );
      }
    } else {
      const year = moment().get('year') - 1;
      let month = moment().get('month') + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      this.props.setMonthlyDatePickerDate(moment(`${year}${month}01`), null, true);
    }
    document.addEventListener('mousedown', this.handleClickOutsideIcons);
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.monthlyRevenueReport &&
      nextProps.monthlyRevenueReport.lastRequestResponse &&
      !this.state.stylists.length
    ) {
      const monthly = nextProps.monthlyRevenueReport.lastRequestResponse;
      let longest = [];
      if (Object.keys(monthly).length > 0) {
        const stylistGroupsArr = Object.values(monthly).map((revenue) => revenue.stylist_group);

        for (let i = 0; i < stylistGroupsArr.length; i += 1) {
          if (stylistGroupsArr[i].length > longest.length) {
            longest = stylistGroupsArr[i];
          }
        }
        const stylists = [];
        for (let i = 0; i < longest.length; i += 1) {
          stylists.push({
            name: longest[i].name,
            id: longest[i].id,
            status: longest[i].status,
            is_self_employed: longest[i].is_self_employed,
          });
        }
        this.setState({ stylists });
      }
    }
    if (
      nextProps.lastMonthlyDatesSelected &&
      this.props.lastMonthlyDatesSelected &&
      moment(nextProps.lastMonthlyDatesSelected.fromDate).toISOString() !==
        moment(this.props.lastMonthlyDatesSelected.fromDate).toISOString()
    ) {
      this.setState({ fromDateChanged: true });
    }
    if (
      nextProps.lastMonthlyDatesSelected &&
      this.props.lastMonthlyDatesSelected &&
      moment(nextProps.lastMonthlyDatesSelected.toDate).toISOString() !==
        moment(this.props.lastMonthlyDatesSelected.toDate).toISOString()
    ) {
      this.setState({ toDateChanged: true });
    }
    setTimeout(() => {
      if (this.state.fromDateChanged || this.state.toDateChanged) {
        if (
          moment(nextProps.lastMonthlyDatesSelected.toDate).diff(
            moment(nextProps.lastMonthlyDatesSelected.fromDate),
            'month',
          ) <= 12
        ) {
          if (!nextProps.lastMonthlyDatesSelected.isFromDate) {
            this.props.getMonthlyRevenue(
              this.props.salonId,
              nextProps.lastMonthlyDatesSelected.fromDate,
              nextProps.lastMonthlyDatesSelected.toDate,
            );
            this.setState({ fromDateChanged: false, toDateChanged: false });
          }
        }
      } else if (!this.props.monthlyRevenueReport) {
        this.props.getMonthlyRevenue(
          this.props.salonId,
          nextProps.lastMonthlyDatesSelected.fromDate,
          nextProps.lastMonthlyDatesSelected.toDate,
        );
        this.setState({ fromDateChanged: false, toDateChanged: false });
      }
    }, 2000);

    if (
      nextProps.lastMonthlyDatesSelected &&
      nextProps.lastMonthlyDatesSelected.fromDate &&
      !this.props.lastMonthlyDatesSelected
    ) {
      if (
        moment(nextProps.lastMonthlyDatesSelected.fromDate).isBefore(
          moment(nextProps.lastMonthlyDatesSelected.toDate),
        ) &&
        moment(nextProps.lastMonthlyDatesSelected.toDate).diff(
          moment(nextProps.lastMonthlyDatesSelected.fromDate),
          'month',
        ) <= 12
      ) {
        this.props.getMonthlyRevenue(
          this.props.salonId,
          nextProps.lastMonthlyDatesSelected.fromDate,
          nextProps.lastMonthlyDatesSelected.toDate,
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.setSalonVatRate(0);
    document.removeEventListener('mousedown', this.handleClickOutsideIcons);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop] && this.props[prop].lastRequestResponse);

  downloadSvg = () => {
    const config = {
      filename: 'customFileName',
    };
    save(D3.select('svg').node(), config);
  };

  handleClickOutsideIcons = (e) => {
    if (!this.myRef.current.contains(e.target)) {
      this.setState({ openDropdown: false });
    }
  };

  clickStaff = () => void this.setState({ openDropdown: !this.state.openDropdown });

  handleSelectStylist = (stylist) => {
    let selectedStylistIds;
    let singleStylist = false;

    if (stylist === STAFF_NAME.all) {
      this.setState({ selectedStaff: STAFF_NAME.all, isEmployed: '' });
    } else if (stylist === STAFF_NAME.employed) {
      this.setState({ selectedStaff: STAFF_NAME.employed, isEmployed: '' });
      selectedStylistIds = this.state.stylists.filter((s) => s.is_self_employed === false).map((s) => s.id);
    } else if (stylist === STAFF_NAME.self) {
      this.setState({ selectedStaff: STAFF_NAME.self, isEmployed: '' });
      selectedStylistIds = this.state.stylists.filter((s) => s.is_self_employed === true).map((s) => s.id);
    } else {
      singleStylist = true;
      selectedStylistIds = this.state.stylists.filter((sty) => sty.name === stylist.name).map((s) => s.id);
    }
    if (selectedStylistIds) {
      if (singleStylist && selectedStylistIds.length) {
        const userId = this.state.stylists.filter((sty) => sty.id === selectedStylistIds[0])[0].id;

        const userName = this.state.stylists.filter((sty) => sty.id === selectedStylistIds[0])[0].name;

        const selfEmployed = this.state.stylists.filter((sty) => sty.id === selectedStylistIds[0])[0].is_self_employed;
        this.setState({ selectedStaff: userName });
        if (userId && !selfEmployed) {
          this.setState({ isEmployed: '(employed)' });
        } else {
          this.setState({ isEmployed: '(self-employed)' });
        }
      }
    }
  };

  render() {
    return (
      <div className="inner-wraper-monthly">
        <div
          className={`select-box-status-bar ${this.state.selectedStaff === STAFF_NAME.all ? ' ' : 'filter-in-used'}`}
        >
          <div className="select-box--box" ref={this.myRef}>
            {this.state.selectedStaff !== STAFF_NAME.all && (
              <span className="select-box--message">Staff filter in use</span>
            )}

            <div
              className={`select-box--container ${this.state.openDropdown ? 'is-open' : ' '}`}
              onClick={this.clickStaff}
              role="button"
              tabIndex={0}
            >
              <span className="select-box--name">Select Staff</span>
              <div className="select-box--selected-item">
                {this.state.selectedStaff} &nbsp;
                {this.state.isEmployed}
              </div>
              <div className="select-box--arrow">
                <span className={`${this.state.openDropdown ? 'arrow-up' : 'arrow-down'}`} />
              </div>
            </div>
            <div className={this.state.openDropdown ? 'A' : 'B'}>
              {this.state.openDropdown && (
                <StylistTypeDropdown
                  openDropdownStylist={this.clickStaff}
                  stylists={this.state.stylists}
                  isStylistOpen={this.state.openDropdown}
                  onSelectStylist={this.handleSelectStylist}
                />
              )}
            </div>
          </div>
        </div>

        {!this.checkIfAllDataIsLoaded() && (
          <div className="spinner-container">
            <div className="load-spinner" />
          </div>
        )}

        <RevenueByStylistMonthlyTableContainer
          monthlyRevenueReport={this.props.monthlyRevenueReport}
          isFetching={this.props.isFetching}
          allDataLoaded={this.checkIfAllDataIsLoaded()}
          selectedStylist={this.state.selectedStaff}
        >
          {this.checkIfAllDataIsLoaded() && (
            <button id="downloadChart" onClick={this.downloadSvg}>
              Download Chart
            </button>
          )}
        </RevenueByStylistMonthlyTableContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lastMonthlyDatesSelected: state.reports.lastMonthlyDatesSelected,
  monthlyRevenueReport: state.reports.monthlyRevenueReport,
  salonId: state.currentSalon.id,
  isFetching: state.reports.isFetching,
  stylistList: state.currentSalon.stylistList,
});

function mapDispatchToProps(dispatch) {
  return {
    setMonthlyDatePickerDate(fromDate, endDate, isFromDate) {
      dispatch(setMonthlyDatePickerDate(fromDate, endDate, isFromDate));
    },
    getMonthlyRevenue(salonId, fromDate, endDate) {
      dispatch(getMonthlyRevenue(salonId, fromDate, endDate));
    },
    setSalonVatRate(vat) {
      dispatch(setSalonVatRate(vat));
    },
    fetchStylistsBySalon(salonId) {
      dispatch(fetchStylistsBySalon(salonId));
    },
  };
}

const MonthlyDashboardReportsHoc = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MonthlyDashboardReports);

export default MonthlyDashboardReportsHoc;
